// extracted by mini-css-extract-plugin
export default {"input":"A8Qxc"};